import { useEffect } from "react";
import { Room, RoomEvent, Participant } from "livekit-client";

export function useParticipantLeave(
  room: Room | undefined,
  onLeave: (participant: Participant) => void
) {
  useEffect(() => {
    if (!room) return;

    const handleLeave = (p: Participant) => {
      onLeave(p);
    };

    room.on(RoomEvent.ParticipantDisconnected, handleLeave);

    return () => {
      room.off(RoomEvent.ParticipantDisconnected, handleLeave);
    };
  }, [room, onLeave]);
}
